import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon, HeartIcon, MapPinIcon, MoonStarIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
const tours = [{
  title: 'Himalayan Hideaway',
  days: '8 days',
  place: 'Kathmandu · Pokhara',
  price: 'From US$ 1,680',
  image: 'https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=1000&q=85'
}, {
  title: 'Chitwan & the Hills',
  days: '7 days',
  place: 'Chitwan · Bandipur',
  price: 'From US$ 1,420',
  image: 'https://images.unsplash.com/photo-1518002054494-3a6f94352e9d?auto=format&fit=crop&w=1000&q=85'
}, {
  title: 'Sacred Valleys Escape',
  days: '9 days',
  place: 'Bhaktapur · Pokhara',
  price: 'From US$ 1,860',
  image: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1000&q=85'
}];
const moreTours = [{
  title: 'Luxury Journeys',
  note: 'Unhurried, elevated Nepal',
  image: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1000&q=85'
}, {
  title: 'Cultural Journeys',
  note: 'Meet the living heritage',
  image: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=1000&q=85'
}];
export function HoneymoonTours() {
  return <div className="min-h-screen bg-[#f8f5ed] text-[#17362e]" data-id="element-562">
      <Header data-id="element-563" />
      <main data-id="element-564">
        <section className="relative flex min-h-[620px] items-end overflow-hidden bg-[#17362e] pb-16 pt-32 text-white sm:min-h-[710px] sm:pb-20" data-id="element-565">
          <img src="https://images.unsplash.com/photo-1528181304800-259b08848526?auto=format&fit=crop&w=2200&q=90" alt="Himalayan landscape for a romantic Nepal journey" className="absolute inset-0 h-full w-full object-cover opacity-80" data-id="element-566" />
          <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(10,32,25,0.76),rgba(10,32,25,0.12)_72%),linear-gradient(0deg,rgba(10,32,25,0.68),transparent_60%)]" data-id="element-567" />
          <div className="relative mx-auto w-full max-w-[1440px] px-5 sm:px-8 lg:px-12" data-id="element-568">
            <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#c8dfbd]" data-id="element-569">
              Tour in Nepal · Private journeys
            </p>
            <h1 className="mt-5 max-w-3xl font-serif text-5xl leading-[0.98] sm:text-7xl" data-id="element-570">
              Honeymoon
              <br data-id="element-571" />
              <i className="font-normal" data-id="element-572">Tours in Nepal</i>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-7 text-white/85" data-id="element-573">
              A beautiful beginning, written in mountain light, quiet lodges,
              and time that belongs entirely to you.
            </p>
          </div>
        </section>

        <section className="py-20 sm:py-28" data-id="element-574">
          <div className="mx-auto grid max-w-[1180px] gap-10 px-5 sm:px-8 lg:grid-cols-[0.7fr_1.3fr]" data-id="element-575">
            <div data-id="element-576">
              <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-577">
                A journey for two
              </p>
              <HeartIcon className="mt-5 h-7 w-7 text-[#4f8057]" strokeWidth={1.4} data-id="element-578" />
            </div>
            <div data-id="element-579">
              <h2 className="font-serif text-4xl leading-tight sm:text-5xl" data-id="element-580">
                Make space for the moments that stay.
              </h2>
              <p className="mt-6 max-w-2xl text-lg leading-8 text-[#52635a]" data-id="element-581">
                From a sunrise over the Annapurnas to a private dinner in the
                Kathmandu Valley, our honeymoon journeys pair Nepal’s
                extraordinary landscapes with thoughtful, quietly luxurious
                details.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-[#e7e7db] py-20 sm:py-28" data-id="element-582">
          <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-583">
            <div className="flex items-end justify-between gap-5" data-id="element-584">
              <div data-id="element-585">
                <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-586">
                  Curated escapes
                </p>
                <h2 className="mt-4 font-serif text-4xl sm:text-5xl" data-id="element-587">
                  Honeymoon Tours
                </h2>
              </div>
              <MoonStarIcon className="h-7 w-7 text-[#4f8057]" strokeWidth={1.4} data-id="element-588" />
            </div>
            <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-589">
              {tours.map(tour => <article key={tour.title} className="group flex flex-col bg-[#f8f5ed]" data-id="element-590">
                  <img src={tour.image} alt={tour.title} className="h-64 w-full object-cover transition duration-700 group-hover:scale-[1.02]" data-id="element-591" />
                  <div className="flex flex-1 flex-col p-6" data-id="element-592">
                    <h3 className="font-serif text-2xl" data-id="element-593">{tour.title}</h3>
                    <div className="mt-5 flex flex-wrap gap-3 text-[10px] font-bold uppercase tracking-[0.13em] text-[#65766a]" data-id="element-594">
                      <span data-id="element-595">{tour.days}</span>
                      <span className="flex items-center gap-1" data-id="element-596">
                        <MapPinIcon className="h-3.5 w-3.5 text-[#4f8057]" data-id="element-597" />
                        {tour.place}
                      </span>
                    </div>
                    <div className="mt-6 flex items-center justify-between border-t border-[#d2d8ce] pt-4" data-id="element-598">
                      <span className="font-serif text-lg" data-id="element-599">{tour.price}</span>
                      <a href="/#contact" aria-label={`Ask about ${tour.title}`} className="flex h-9 w-9 items-center justify-center border border-[#8b998e] transition hover:bg-[#17362e] hover:text-white" data-id="element-600">
                        <ArrowUpRightIcon className="h-4 w-4" data-id="element-601" />
                      </a>
                    </div>
                  </div>
                </article>)}
            </div>
          </div>
        </section>

        <section className="py-20 sm:py-28" data-id="element-602">
          <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-603">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#4f8057]" data-id="element-604">
              Continue exploring
            </p>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl" data-id="element-605">
              Looking for Other Tours?
            </h2>
            <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-606">
              {moreTours.map(tour => <a key={tour.title} href="/#treks" className="group relative block h-72 overflow-hidden text-white" data-id="element-607">
                  <img src={tour.image} alt={tour.title} className="h-full w-full object-cover transition duration-700 group-hover:scale-105" data-id="element-608" />
                  <span className="absolute inset-0 bg-[#17362e]/45" data-id="element-609" />
                  <span className="absolute inset-x-0 bottom-0 p-7" data-id="element-610">
                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#c8dfbd]" data-id="element-611">
                      {tour.note}
                    </span>
                    <span className="mt-2 flex items-center justify-between font-serif text-3xl" data-id="element-612">
                      {tour.title}
                      <ArrowRightIcon className="h-5 w-5" data-id="element-613" />
                    </span>
                  </span>
                </a>)}
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-614" />
    </div>;
}